import moment from "moment";

const dateVariable = new Date(); // Your date variable

const getDate = (date) => moment(date).format("DD-MM-YYYY");
const getTime = (date) => moment(date).format("HH:mm:ss");
const getDateTime = (date) => moment(date).format("DD-MM-YYYY HH:mm:ss");

export { getDate, getTime, getDateTime };
